import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePatientLongTermMedications = (patientId) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientlongTermMedications", tenantVal, patientId],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientmedication/groupedbypatientidandtype/${patientId}/LONGTERM`
      );
      return response?.data;
    },
    enabled: !!tenantVal && !!patientId,
  });
};
